<div class="container">
    <h2>Login</h2>
    <form id="login">
        <mat-form-field appearance="fill">
            <mat-label>Enter your username</mat-label>
            <input matInput #username placeholder="Username..." autocomplete="username">
          </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Enter your password</mat-label>
            <input type="password" autocomplete="password" matInput #password placeholder="Password...">
          </mat-form-field>

        <button mat-raised-button color="primary" (click)="logIn($event)">Login</button>
    </form>
    <div *ngIf = "displayErrMessage" class="errMessage">
      {{errMessage}}
    </div>
  </div>